import type { Component, JSX } from 'solid-js';
import { Show, createEffect, createSignal, onCleanup } from 'solid-js';

export const TRANSIENT_BANNER_DURATION_MS = 10_000;

type Props = {
  message: string;
  class: string;
  as?: 'div' | 'p';
  role?: JSX.AriaAttributes['role'];
  testId?: string;
  durationMs?: number;
  /** Clears the owning screen's message state after this element unmounts. */
  onDismiss?: (() => void) | undefined;
};

/**
 * Removes transient status messages from layout after they have been read.
 * Hiding only their contents leaves a flex/grid gap behind, which is why the
 * old animation could shrink into a thin, empty strip.
 */
export const TransientBanner: Component<Props> = (props) => {
  const [visible, setVisible] = createSignal(true);

  createEffect(() => {
    props.message;
    setVisible(true);
    const timer = window.setTimeout(() => {
      setVisible(false);
      props.onDismiss?.();
    }, props.durationMs ?? TRANSIENT_BANNER_DURATION_MS);
    onCleanup(() => window.clearTimeout(timer));
  });

  return (
    <Show when={visible()}>
      <Show
        when={props.as === 'p'}
        fallback={
          <div class={props.class} role={props.role ?? 'status'} data-testid={props.testId}>
            {props.message}
          </div>
        }
      >
        <p class={props.class} role={props.role ?? 'status'} data-testid={props.testId}>
          {props.message}
        </p>
      </Show>
    </Show>
  );
};
